import { oc } from '@orpc/contract';
import { applyTemplatePreviewInputSchema, applyTemplatePreviewOutputSchema } from '../schemas/estimates.schemas.js';
/** What applying that template would change, old → new, before anything is written (PP AC09). */
export const previewEstimateTemplateContract = oc
    .route({
    method: 'GET',
    path: '/estimates/{estimateId}/apply-template-preview',
    tags: ['Estimates'],
    summary: 'Preview the fields a template change would replace',
})
    .input(applyTemplatePreviewInputSchema)
    .output(applyTemplatePreviewOutputSchema);
//# sourceMappingURL=preview-estimate-template.contract.js.map